// extracted by mini-css-extract-plugin
export var active = "NumberedList-module--active--0ebb9";
export var stepsContent = "NumberedList-module--stepsContent--fde68";
export var tabContent = "NumberedList-module--tabContent--cd541";
export var tabPanel = "NumberedList-module--tabPanel--328e0";
export var tabsWrapper = "NumberedList-module--tabsWrapper--097b4";